import { Button, css, styled } from 'canoe';
import React, { ReactNode } from 'react';

import { ButtonProps } from 'canoe/components/Button';

const StyledButton = styled(Button)<{
  isActive?: boolean;
}>`
  ${({ theme, isActive }) => css`
    height: 32px;
    background-color: ${theme.colors.GlitterGrayL20};
    border: 1px solid ${theme.colors.GlitterGray};
    padding: 6px;
    font-size: 13px;

    &:hover,
    &:active,
    &:focus {
      background-color: ${theme.colors.GlitterGrayL10};
      border-color: ${theme.colors.GlitterGray};
      box-shadow: none;
    }

    ${isActive &&
    css`
      border-color: ${theme.colors.BrandPurple};

      &:hover,
      &:active,
      &:focus {
        border-color: ${theme.colors.BrandPurple};
      }
    `}
  `}
`;

export interface ValueButtonProps {
  children: ReactNode;
  onClick?: () => void;
  isActive?: boolean;
  fullWidth?: boolean;
}

export const ValueButton = React.forwardRef<HTMLButtonElement>(
  (
    {
      children,
      onClick,
      isActive,
      fullWidth = true,
      fontWeight = 'normal',
      ...rest
    }: ValueButtonProps & ButtonProps,
    ref,
  ) => {
    return (
      <StyledButton
        ref={ref}
        onClick={onClick}
        isActive={isActive}
        fullWidth={fullWidth}
        fontWeight={fontWeight}
        {...rest}
        size="small"
        variant="neutral"
      >
        {children}
      </StyledButton>
    );
  },
);
